// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"DevSidebar_sidebar__2JLzL"};